import { specialFont } from '../../../../../Infrastructure/Theme/fontFamily';

export const classDetailsSx = {
    pageWrapper: { position: 'relative' },
    backArrowBox: { cursor: 'pointer', position: "absolute", top: 4, left: 0, display: 'inline-block' },
    content: { width: { xs: '100%' }, display: 'flex', flexDirection: "column", gap: 5, px: { xs: 0, md: 5 }, mb: 4 },
    title: { fontSize: { xs: "20px", sm: "24px" }, textTransform: 'capitalize', fontFamily: specialFont, ml: { xs: 3, sm: 0 } },
    gridContainer: { px: { xs: 0, md: 3 } },
    courseImageBox: { cursor: 'pointer', borderTop: '4px solid #ccc', borderBottom: '4px solid #ccc', borderRadius: "32px", overflow: 'hidden', position: 'relative' },
    skeletonAbsolute: { position: 'absolute', top: 0, left: 0 },
    educatorBox: { cursor: 'pointer' },
    avatarBox: { borderRadius: "50%", height: '80px', width: '80px', overflow: 'hidden', position: 'relative' },
    avatarImage: { height: '100%', width: '100%', objectFit: 'cover', borderRadius: '50%', display: 'block' },
    educatorName: { fontSize: "16px" },
    rating: { fontSize: "1.2rem" },
    scheduleContainer: { borderRadius: '30px', p: 3 },
    underlineValueText: { textDecoration: "underline" }
};
